{
  "title": "Summon Fiend",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "6th-level conjuration",
  "level": 6,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (humanoid blood inside a ruby vial worth at least 600 gp)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You call forth a fiendish spirit. It manifests in an unoccupied space that you can see within range. This corporeal form uses the Fiendish Spirit stat block. When you cast the spell, choose Demon, Devil, or Yugoloth. The creature resembles a fiend of the chosen type, which determines certain traits in its stat block. The creature disappears when it drops to 0 hit points or when the spell ends.",
    "The creature is an ally to you and your companions. In combat, the creature shares your initiative count, but it takes its turn immediately after yours. It obeys your verbal commands (no action required by you). If you don’t issue any, it takes the Dodge action and uses its move to avoid danger.",
    "At Higher Levels. When you cast this spell using a spell slot of 7th level or higher, use the higher level wherever the spell’s level appears in the stat block.",
    "Fiendish Spirit",
    "Large fiend",
    "Armor Class: 12 + the level of the spell (natural armor)",
    "Hit Points: 50 (Demon only) or 40 (Devil only) or 60 (Yugoloth only) + 15 for each spell level above 6th",
    "Speed: 40 ft., climb 40 ft. (Demon only), fly 60 ft. (Devil only)",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "13 (+1)",
    "16 (+3)",
    "15 (+2)",
    "10 (+0)",
    "10 (+0)",
    "16 (+3)",
    "Damage Resistances: fire",
    "Damage Immunities: poison",
    "Condition Immunities: poisoned",
    "Senses: darkvision 60 ft., passive Perception 10",
    "Languages: Abyssal, Infernal, telepathy 60 ft.",
    "Challenge: —",
    "Proficiency Bonus: equals your bonus",
    "Death Throes (Demon Only). When the fiend drops to 0 hit points or the spell ends, the fiend explodes, and each creature within 10 feet of it must make a Dexterity saving throw against your spell save DC. A creature takes 2d10 + the spell’s level fire damage on a failed save, or half as much damage on a successful one.",
    "Devil’s Sight (Devil Only). Magical darkness doesn’t impede the fiend’s darkvision.",
    "Magic Resistance. The fiend has advantage on saving throws against spells and other magical effects.",
    "Actions",
    "Multiattack. The fiend makes a number of attacks equal to half this spell’s level (rounded down).",
    "Bite (Demon Only). Melee Weapon Attack: your spell attack modifier to hit, reach 5 ft., one target. Hit: 1d12 + 3 + the spell’s level necrotic damage.",
    "Claws (Yugoloth Only). Melee Weapon Attack: your spell attack modifier to hit, reach 5 ft., one target. Hit: 1d8 + 3 + the spell’s level slashing damage. Immediately after the attack hits or misses, the fiend can magically teleport up to 30 feet to an unoccupied space it can see.",
    "Hurl Flame (Devil Only). Ranged Spell Attack: your spell attack modifier to hit, range 150 ft., one target. Hit: 2d6 + 3 + the spell’s level fire damage. If the target is a flammable object that isn’t being worn or carried, it also catches fire."
  ],
  "spellLists": ["warlock", "wizard"]
}
